import { useFeatureFlagEnabled } from 'posthog-js/react';

import { POSTHOG_FEATURE_FLAG_DEFAULTS, type PostHogFeatureFlag } from './posthogFeatureFlags';

export function usePostHogFeatureFlag(key: PostHogFeatureFlag): boolean {
  // `useFeatureFlagEnabled` is `undefined` while flags load / PostHog is
  // unconfigured — fall back to the configured default for the key.
  return useFeatureFlagEnabled(key) ?? POSTHOG_FEATURE_FLAG_DEFAULTS[key] ?? false;
}
